import * as React from 'react';
import * as styles from './styles.css';

export interface IDropdownWrapperProps {
  children: React.ReactNode;
}

export function DropdownWrapper({ children }: IDropdownWrapperProps) {
  return <div className={styles['dropdown']}>{children}</div>;
}
